export enum ContinentCodes {
  Africa = 'AF',
  Asia = 'AS',
  Europe = 'EU',
  NorthAmerica = 'NA',
  Oceania = 'OC',
  SouthAmerica = 'SA',
}
